import { render, staticRenderFns } from "./AddToTalentPool.vue?vue&type=template&id=7bb381b5&"
import script from "./AddToTalentPool.vue?vue&type=script&lang=js&"
export * from "./AddToTalentPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports